import {useSetAgencyOwnerMutation} from "@/api/agencyApi";
import UserAvatarPlaceholder from "@/assets/images/user_avatar_placeholder.svg";
import Modal from "@/components/Common/Modal";
import type {TAccountMember} from "@/store/types";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const ChangeAgencyOwnershipModal: FC<{
  agencyId: number;
  agencyMember: TAccountMember;
  onClose: () => void;
}> = ({agencyId, agencyMember, onClose}) => {
  const {t} = useTranslation("multi_account");
  const {isPending, mutate: setAgencyOwner} = useSetAgencyOwnerMutation({agencyId});

  return (
    <Modal
      backgroundClassName="max-w-150"
      isLoading={isPending}
      modalTitle={t("change_agency_ownership")}
      onClose={onClose}
      onConfirm={() => setAgencyOwner({userId: agencyMember.user.id}, {onSuccess: onClose})}
      shouldCloseOnConfirm={false}>
      <div className="flex flex-col items-center gap-5">
        <span className="text-neutral-black">{t("change_agency_ownership_to")}</span>
        <div className="border-neutral-grey-light-dark flex items-center gap-2 rounded-full border p-1 pr-2">
          <div className="size-6 shrink-0 rounded-full">
            <img
              src={agencyMember.user.profile_picture ?? UserAvatarPlaceholder}
              className="h-full w-full rounded-full"
            />
          </div>
          <span className="bg-linear-(--primary-dark-gradient) bg-clip-text font-semibold text-transparent">
            {agencyMember.user.first_name} {agencyMember.user.last_name}
          </span>
        </div>
        <div className="bg-warning-light-yellow flex self-stretch rounded-md px-4 py-5">
          <span className="text-warning-dark-yellow text-center text-lg font-semibold">
            {t("change_agency_ownership_warning_title")}
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default ChangeAgencyOwnershipModal;
